// extracted by mini-css-extract-plugin
module.exports = {"editorHolder":"TeacherChapter_editorHolder__319-f"};